
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","viewBox":"0 0 34 34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.6 10.1h-1.2c0-.3.1-.5.1-.8 0-4.1-3.5-7.6-7.6-7.6S9.3 5.2 9.3 9.3c0 .3 0 .5.1.8H8.3c-.5 0-1 .4-1 1v18c0 .5.4 1 1 1h17.3c.5 0 1-.4 1-1v-18c0-.5-.5-1-1-1zm-14.3-.8c0-3 2.6-5.6 5.6-5.6 3 0 5.6 2.6 5.6 5.6 0 .3 0 .5-.1.8h-11c-.1-.3-.1-.5-.1-.8zm13.3 18.8H9.3v-16h15.3v16z","fill":"#47AEA6"}}),_c('path',{attrs:{"d":"M29.1 29.4l-4.5-4.8c.9-1.2 1.4-2.5 1.4-4 0-3.6-3-6.6-6.6-6.6-3.6 0-6.6 3-6.6 6.6 0 3.6 3 6.6 6.6 6.6 1.3 0 2.4-.3 3.5-1l4.5 4.8c.2.2.6.3.8.3.2 0 .6-.1.8-.3.6-.3.6-1.1.1-1.6zm-13.8-8.8c0-2.3 2-4.3 4.3-4.3s4.3 2 4.3 4.3c0 1.3-.6 2.4-1.4 3.1-.7.7-1.7 1-2.8 1-2.5.1-4.4-1.8-4.4-4.1z","fill":"#F9A91E"}})])
          )
        }
      }
    